export default "__VITE_ASSET__DlqshIIh__"